import { HomeLightbulbOutlineIcon } from './HomeLightbulbOutlineIcon';

/**
 * author: Michael Richins
 * id 5F0E0727-76E9-4793-9406-FD513FF7CB58
 * name home-lightbulb-outline
 * version: 4.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-lightbulb-outline.svg
 * tags
 * - Home Automation 
 */
export const HomeBulbOutlineIcon = HomeLightbulbOutlineIcon;
export default HomeBulbOutlineIcon